import { Heading, HeadingProps } from '@chakra-ui/react';
import * as React from 'react';

export const MainHeading: React.FC<HeadingProps> = (props) => (
  <Heading size={'md'} {...props} />
);
export const SubHeading: React.FC<HeadingProps> = (props) => (
  <Heading size={'xs'} {...props} />
);
